<div class="main_content px-3 position-relative w-100">
  <div class="container-fluid py-3">
    <div class="title mb-2">
      <h2 class="base_url review_list">name list</h2>
    </div>
    <div class="white_box shadow p-3">
      <div class="d-flex align-items-center flex-wrap mb-3 gray_box">
        <button class="btn btn-dark" (click)="open(content)">
          Add Name
        </button>
      </div>

      <div class="row">
        <div class="col-lg-12 col-md-12">
          <div class="row">
            <div class="col-lg-12 col-md-12">
              <div class="goo_bg">
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">S.No.</th>
                      <th scope="col">Name</th>
                      <th scope="col">Phone No</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Link</th>
                      <th scope="col">Created</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of getallname; let i = index">
                      <td>{{ i + 1 }}</td>
                      <td
                        class="{{ (data?.manual_one_count + data?.manual_two_count + data?.manual_three_count) >= 3 ? 'text-danger' : (data?.manual_one_count + data?.manual_two_count + data?.manual_three_count) == 2 ? 'text-primary' :  ''}}">
                        {{ data.name }}</td>
                      <td>{{ data.phno }}</td>
                      <td>
                        {{ data.amount }} &nbsp;
                        <a (click)="editAmount(amount, data.id, data)" class="btn btn-info float-right">
                          <i class="fas fa-edit"></i>
                        </a>
                      </td>
                      <td>
                        <a href="{{ openLink(data.link) }}" target="_blank"> Click to open</a>
                        &nbsp;
                        &nbsp;
                        <i title="Click to copy" style="cursor: pointer;" class="fa fa-clipboard"
                          [cdkCopyToClipboard]="data.link" aria-hidden="true" (click)="copyToClipboardMessage()"></i>
                      </td>
                      <td>{{ data.created * 1000 | date : "medium" }}</td>
                      <td>
                        <a (click)="delName(data.id)" class="btn btn-danger">
                          <i class="fas fa-trash"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Add Name</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="addname">
      <div class="mb-3">
        <label for="dateOfBirth">Name</label>
        <div class="input-group">
          <input type="text" id="dateOfBirth" formControlName="name" class="form-control" placeholder="Enate Name" />
          <ng-container *ngIf="submitted && addnameValidation.name.errors">
            <p class="error-message-repair" *ngIf="addnameValidation.name.errors.required">
              Name is required!
            </p>
          </ng-container>
        </div>
      </div>
      <div class="mb-3">
        <label for="phno">Phone No</label>
        <div class="input-group">
          <input type="text" id="phno" formControlName="phno" class="form-control" placeholder="Enter Phone No" />
          <ng-container *ngIf="submitted && addnameValidation.phno.errors">
            <p class="error-message-repair" *ngIf="addnameValidation.phno.errors.required">
              Phone No is required!
            </p>
          </ng-container>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-dark" (click)="saveData()">
      Save
    </button>
  </div>
</ng-template>


<ng-template #amount let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Edit Amount</h4>
      <!-- <h3 class="text-center">Edit Review</h3> -->

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
      <!-- <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button> -->
    </div>
    <form action="">
      <div class="modal-body">
        <form [formGroup]="editFG">
          <div class="form-group">
            <input [(ngModel)]="manual_one_checked" type="checkbox" formControlName="manual_one">
            <label for="vehicle1">G</label> &nbsp; &nbsp;
            <input [(ngModel)]="manual_two_checked" type="checkbox" formControlName="manual_two">
            <label for="vehicle1">FB</label> &nbsp; &nbsp;
            <input [(ngModel)]="manual_three_checked" type="checkbox" formControlName="manual_three">
            <label for="vehicle1">M3</label>
            <br>
            <!-- <textarea class="form-control" placeholder="Write feedback"
              formControlName="amount">{{ nameData.amount }}</textarea> -->
            <input type="text" class="form-control" placeholder="Enter amount" formControlName="amount">
            <ng-container *ngIf="submitted && editAmountValidation.amount.errors">
              <p class="error-message-repair" *ngIf="editAmountValidation.amount.errors.required">
                Amount is required!
              </p>
            </ng-container>
            <br>
            <input type="text" class="form-control" placeholder="Enter name" formControlName="name">
            <ng-container *ngIf="submitted && editAmountValidation.name.errors">
              <p class="error-message-repair" *ngIf="editAmountValidation.name.errors.required">
                Name is required!
              </p>
            </ng-container>

          </div>
          <div class="text-center">
            <button class="btn btn-dark mx-auto" (click)="updateAmount()">
              Update
            </button>
          </div>
        </form>
      </div>
    </form>
  </div>
</ng-template>